import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--btn-bg)] text-[var(--btn-text)] shadow hover:bg-[var(--btn-hover)]",
        destructive:
          "bg-[var(--btn-destructive-bg)] text-[var(--btn-destructive-text)] shadow-sm hover:bg-[var(--btn-destructive-hover)]",
        outline:
          "border border-[var(--btn-outline-border)] bg-transparent shadow-sm hover:bg-[var(--btn-outline-hover-bg)] hover:text-[var(--btn-outline-hover-text)]",
        secondary:
          "bg-[var(--btn-secondary-bg)] text-[var(--btn-secondary-text)] shadow-sm hover:bg-[var(--btn-secondary-hover)]",
        ghost: "hover:bg-[var(--btn-ghost-hover-bg)] hover:text-[var(--btn-text)]",
        link: "text-[var(--btn-bg)] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
